import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { useValidateTokenQuery } from '../redux/slices/views';
import { buildLoginUrlWithRedirect } from '../services/authRedirect';

const TokenHandler: React.FC<{ onDone: () => void }> = ({ onDone }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const token = query.get('t');

  const { data, isSuccess, isError, isFetching } = useValidateTokenQuery(token as string, {
    skip: !token,
  });

  useEffect(() => {
    if (!token) {
      onDone();
      return;
    }
    if (isSuccess && data) {
      localStorage.setItem('AccessToken', token);
      localStorage.setItem('isAuthenticated', JSON.stringify(true));
      localStorage.setItem('user', JSON.stringify(data));

      query.delete('t');
      const params = query.toString();
      const redirectPath = location.pathname + (params ? `?${params}` : '');
      navigate(redirectPath, { replace: true });
      onDone();
    } else if (isError && !isFetching) {
      // If validation fails, clear and redirect to login, preserving intended URL for after login (strip token from query)
      localStorage.removeItem('AccessToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user');
      const query = new URLSearchParams(location.search);
      query.delete('t');
      const searchWithoutToken = query.toString();
      const loginUrl = buildLoginUrlWithRedirect(
        location.pathname,
        searchWithoutToken ? `?${searchWithoutToken}` : ''
      );
      navigate(loginUrl, { replace: true });
      onDone();
    }
    // eslint-disable-next-line
  }, [isSuccess, isError, isFetching, data, token, location, navigate]);

  return null;
};

export default TokenHandler;
